import React, { useEffect, useState } from 'react'
import { StyleSheet, Text, View, Dimensions, Image, TouchableOpacity } from 'react-native'
import { FormContentsModel, ModelAnswerFromProps } from '../models/StoreDetailModel'
import styles from './InputCommentNoEditItemStyles'
import theme from '../../../../theme'
import { schedulesServices } from '../../../../database/schedules.database'
import { useBottomSheet } from '../../customUtils/context/BottomSheetContext'
import { ImageWithZoom } from '../../customUtils/Components/ImageWIthZoom'
import useImageLoader from '../../../hooks/useImageLoader'
import { PATH_ASSETS } from '../../../utils/Constants'
import { Loader } from '../../customUtils/Components/Loader'

const deviceWidth = Dimensions.get('window').width

interface InputCommentNoEditItemProps {
    item: FormContentsModel
    form_id: string
    schedule_id: string
    store_id: string
    checkComplete: (option?: ModelAnswerFromProps) => void
}

export const InputCommentNoEditItem = React.memo(({ item, form_id, schedule_id, store_id, checkComplete }: InputCommentNoEditItemProps) => {
    const [hasCreatedAnswer, setHasCreatedAnswer] = useState(false)

    useEffect(() => {
        // ✅ Solo crear respuesta UNA VEZ al montar, no en cada cambio de item
        if (item && !hasCreatedAnswer) {
            create_answer()
            setHasCreatedAnswer(true)
        }
    }, []) // ✅ Array vacío = solo al montar
    const { image, loading, placeholderGeneral } = useImageLoader(item.media, PATH_ASSETS)
    const [preview, setPreview] = useState(image)
    useEffect(() => {
        setPreview(image)
    }, [image])

    const create_answer = async () => {
        let answerScore = '0'
        if (item.score != null && item.score > 0) answerScore = item.score.toString()
        const answer: ModelAnswerFromProps = {
            _id: item._id,
            option_selected_text: [],
            option_selected_id: [],
            question_id: item._id,
            media: '',
            question_text: item.title,
            score: answerScore,
            status: 1,
            date_finish: new Date().toString(),
            date_init: new Date().toString(),
            question_input: item.questionInput,
            field_media: '',
            field_text: '',
            questionScore: item.questionScore,
            type: item.input_type.type,
            ponderar: item.score && item.score > 0, // [7, 8, 14, 18].includes(item.input_type.type),
            question: item.title,
            questionOptionSelected: [],
            questionOptionSelectedText: [],
            questionType: {
                title: item.input_type.title,
                type: item.input_type.type,
                id: item.input_type._id,
            },
            questionPrice: '',
            description: '',
            tag: '',
            questionImage: '',
            questionInput: item.questionInput,
        }

        // ✅ FIX: Usar checkComplete en lugar de updateFormAnswerSchedule directo
        // checkComplete tiene protección para esperar a que el registro esté creado
        await checkComplete(answer)
    }
    const { openBottomSheet, closeBottomSheet } = useBottomSheet()

    const openBigImage = () => {
        if (image) {
            openBottomSheet(<ImageWithZoom uri={image} contentSeen={() => {}} path={''} />, undefined, undefined, true, true, true)
        }
    }
    return (
        <View style={styles.flexDirectionRow}>
            {item.media && (
                <TouchableOpacity onPress={() => openBigImage()}>
                    {loading ? (
                        <Loader />
                    ) : (
                        <Image
                            style={styles.image}
                            source={{ uri: preview }}
                            onError={(e) => {
                                setPreview(placeholderGeneral)
                            }}
                        />
                    )}
                </TouchableOpacity>
            )}
            <View>
                <Text style={styles.title}>{item.title}</Text>
                <View style={styles.opacity}>
                    <Text style={styles.input}>{item.questionInput}</Text>
                </View>
                <View style={styles.dividerHorizontalLine}></View>
            </View>
        </View>
    )
})
